export const levelTypesSelector = ({ levelTypes: { levels: value = [] } }: any) => value;
export const defaultLevelSelector = ({ levelTypes: { defaultLevel: value } }: any) => value;
